import type { ToolBadgeSpec } from '../types.js';

import { makeFlightExtractor } from '../extractors.js';

const extractOutbound = makeFlightExtractor('outbound');
const extractReturn = makeFlightExtractor('return');

export const fetchFlightDataSpec: ToolBadgeSpec = {
  toolName: 'fetchFlightData',
  aliases: ['searchFlights'],
  icon: 'flight_takeoff',
  label: (_, active) => (active ? 'Searching for outbound flights' : 'Searched for outbound flights'),
  activitySummary: {
    key: 'flightSearch',
    label: (_, active) => (active ? 'Searching for flights' : 'Searched for flights'),
  },
  resultNoun: { singular: 'outbound flight', plural: 'outbound flights' },
  dataSource: 'Google Flights',
  extractResults: (toolCall) => extractOutbound(toolCall.output),
};

export const resumeFlightSearchWorkflowSpec: ToolBadgeSpec = {
  toolName: 'resumeFlightSearchWorkflow',
  icon: 'flight_land',
  label: (_, active) => (active ? 'Searching for return flights' : 'Searched for return flights'),
  activitySummary: {
    key: 'flightSearch',
    label: (_, active) => (active ? 'Searching for flights' : 'Searched for flights'),
  },
  resultNoun: { singular: 'return flight', plural: 'return flights' },
  dataSource: 'Google Flights',
  extractResults: (toolCall) => extractReturn(toolCall.output),
};
